var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tooltip-container" },
    [
      _c("i", {
        class: "fa " + _vm.icon,
        style: {
          color: _vm.iconColor,
          cursor: _vm.showModalOnClick ? "pointer" : "default",
        },
        on: {
          click: function ($event) {
            _vm.showModalOnClick && _vm.open()
          },
        },
      }),
      _vm._v(" "),
      _vm.tooltipVisible
        ? _c("div", { staticClass: "tooltip-content" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.showModalOnClick
                    ? "Clique no icone para exibir detalhes"
                    : _vm.text
                    ? _vm.text.replaceAll(" ", " ")
                    : ""
                ) +
                "\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "shortcutComponent",
        {
          ref: "shortCutComponent",
          attrs: { showBtnOk: false, modalClass: "lm-h-flex-modal" },
          on: { "hide-click": _vm.showTooltip },
        },
        [
          _c(
            "div",
            { attrs: { slot: "component" }, slot: "component" },
            [_c("vue-markdown-it", { attrs: { source: _vm.modalText } })],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }